import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const getStyles = () => ({
  progressBar: {
    margin: '0 4px',
    height: '100%',
    width: '4.5px',
    backgroundColor: 'rgba(36, 36, 36, 0.2)',
    borderRadius: 20,
  },
  progressValue: ({ percent }) => ({
    height: `${percent}%`,
    width: '4.5px',
    backgroundColor: '#0f6cbd',
    borderRadius: 20,
  }),
});

export const VerticalProgressBar = ({
  max,
  value,
  index,
  className,
}) => {
  const i18n = useContext(I18nContext);
  const percent = (value / max) * 100;
  const classes = useDefaultStyles(getStyles, { percent });

  return (
    <div
      className={classNames('vertical-progress-bar', className, classes.progressBar)}
      role="progressbar"
      aria-label={i18n.getString(_TL_('Progress bar {{index}}'), { index: index + 1 })}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={value}
    >
      <div className={classNames('progress-bar-value', classes.progressValue)} />
    </div>
  );
};

VerticalProgressBar.propTypes = {
  max: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
  index: PropTypes.number,
};

VerticalProgressBar.defaultProps = {
  className: '',
  index: 0,
};
